import { ObjectChangeTracker } from "@schoolbelle/common/object-change-tracker";
import { FileListService, FileInfoType } from "@schoolbelle/api/file";
import { MailMergeItem } from "@schoolbelle/api/letter";
import { pushMethod } from "@schoolbelle/api/notification-push";
import { isEqual } from 'lodash-es';
import { LetterTranslationsService } from "./letter-translations.serivce";

export class LetterTracker extends ObjectChangeTracker {
    get letter_id ():number {
        return this.get('letter_id');
    }
    set letter_id(v:number) {
        this.set('letter_id', v);
    }
    get type ():string {
        return this.get('type');
    }
    set type (v:string) {
        this.set('type', v);
    }
    get title ():string {
        return this.get('title');
    }
    set title (v:string) {
        this.set('title', v);
    }
    get content ():string {
        return this.get('content');
    }
    set content (v:string) {
        this.set('content', v);
    }
    get targets () {
        return this.get('targets');
    }
    set targets (v) {
        this.set('targets', v);
    }
    get targets_simplified () {
        return this.get('targets_simplified');
    }
    set targets_simplified (v) {
        this.set('targets_simplified', v);
    }
    fileList = new FileListService()
    set files (list:(Blob | FileInfoType)[]) {
        list.forEach(li=>{
            this.fileList.push(li);
        })
    }
    get files () {
        return this.fileList.list;
    }
    get hasMailmerge ():boolean {
        return (this.mailmerge && this.mailmerge.length > 0) || this.get('hasMailmerge');
    }
    set hasMailmerge (v:boolean) {
        this.set('hasMailmerge', v);
    }
    get mailmerge ():MailMergeItem[] {
        return this.get('mailmerge');
    } 
    set mailmerge (v:MailMergeItem[]) {
        this.set('mailmerge', v);
    } 
    get questionnaire_id () {
        return this.get('questionnaire_id');
    }
    get survey_id () {
        return this.get('survey_id');
    }
    get survey_id_g3 () {
        return this.get('survey_id_g3');
    }
    set survey_id_g3 (v:string) {
        this.set('survey_id_g3', v);
    }
    get push_method ():pushMethod {
        return this.get('push_method');
    }
    set push_method (v:pushMethod) {
        this.set('push_method', v);
    }
    get sms_content ():string {
        return this.get('sms_content');
    }
    set sms_content (v:string) {
        this.set('sms_content', v);
    }
    get sms_sender ():string {
        return this.get('sms_sender');
    }
    set sms_sender (v:string) {
        this.set('sms_sender', v);
    }
    
    get author_name ():string {
        return this.get('author_name');
    }
    set author_name (v:string) {
        this.set('author_name', v);
    }

    translations = new LetterTranslationsService()
    get lang ():string {
        return this.get('lang');
    }
    set lang (v:string) {
        this.set('lang', v);
    }    
    _draw_at:Date;
    get draw_at ():Date {
        return this._draw_at;
    }
    set draw_at (v:Date) {
        const new_ms = v && v.getTime();
        const old_ms = this._draw_at && this._draw_at.getTime();
        if (new_ms !== old_ms) {
            if (new_ms) {
                if (!this._draw_at) this._draw_at = new Date();
                this._draw_at.setTime(new_ms);
            } else {
                this._draw_at = null;
            }
            this.set('draw_at', new_ms / 1000);
        } 
        
    }
    _issue_at:Date;
    get issue_at ():Date {
        return this._issue_at;
    }
    set issue_at (v:Date) {
        const new_ms = v && v.getTime();
        const old_ms = this._issue_at && this._issue_at.getTime();
        if (new_ms !== old_ms) {
            if (new_ms) {
                if (!this._issue_at) this._issue_at = new Date();
                this._issue_at.setTime(new_ms);
            } else {
                this._issue_at = null;
            }
            this.set('issue_at', new_ms / 1000);
        } 
    }

    get isChanged():boolean {
        const to = this.to;
        const from = this.from;
        return (
            this.fileList.changed
            || this.translations.changed
            || (to && (typeof to === 'object' && Object.keys(to).length !== 0)) 
            || (from && (typeof from === 'object' && Object.keys(from).length !== 0)) 
            || !isEqual(to, from)
        )
    }  
    constructor () {
        super();
        this.fileList.onChange.subscribe(()=>{
            this.set('files', this.fileList.list);
            this.contentUpdateEvent.next(null)
        });
        this.translations.onChange.subscribe(()=>{
            this.set('translations', this.translations.list)
            this.contentUpdateEvent.next(null)
        })
    }
    load (data?:any) {
        if (data) super.load(data);
        this._issue_at = data && data.issue_at ? new Date(data.issue_at * 1000) : null;
        this._draw_at = data && data.draw_at ? new Date(data.draw_at * 1000) : null;

        this.fileList.splice(0, this.fileList.list.length);
        if (data && data.files && Array.isArray(data.files)) this.fileList.load(data.files);
    }
    overwrite (data:any) {
        super.load(null);
        if (data) super.set([], data);
        this._issue_at = data && data.issue_at ? new Date(data.issue_at * 1000) : null;
        this._draw_at = data && data.draw_at ? new Date(data.draw_at * 1000) : null;
        this.fileList.splice(0, this.fileList.list.length);
        if (data && data.files && Array.isArray(data.files)) this.fileList.load(data.files);
    }
    

}